import React, { useState, useEffect } from "react";
import "../Auth.css";
import { useAuth } from "../../../contexts/authContext";
import { doSignInWithEmailAndPassword } from "../../../firebase/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();
  const { userLoggedIn, currentUser } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSigningIn, setIsSigningIn] = useState(false);

  useEffect(() => {
    if (userLoggedIn) {
      if (currentUser.role === "admin") {
        navigate("/admin");
      } else {
        navigate("/home");
      }
    }
  }, [userLoggedIn, currentUser, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!isSigningIn) {
      setIsSigningIn(true);
      await doSignInWithEmailAndPassword(email, password)
        .then(() => {
          // Navigation will be handled by the useEffect hook based on user role
        })
        .catch((error) => {
          const errorCode = error.code;
          let message = "";

          switch (errorCode) {
            case "auth/invalid-credential":
              message =
                "Invalid email address or password. Please check and try again.";
              break;
            case "auth/too-many-requests":
              message =
                "Too many unsuccessful login attempts. Please try again later.";
              break;
            default:
              message = "An error occurred. Please try again.";
          }
          toast.error(message);
          setIsSigningIn(false);
        });
    }
  };

  return (
    <>
      {userLoggedIn && (currentUser.role === "admin" ? <Navigate to="/admin" /> : <Navigate to="/home" />)}

      <div className="container">
        <div className="form-container">
          <div className="mt-2">
            <h3 className="title">Welcome Back</h3>
          </div>

          <form onSubmit={onSubmit} className="form">
            <div className="form-control">
              <label className="label">Email</label>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
              />
            </div>

            <div className="form-control">
              <label className="label">Password</label>
              <input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
              />
            </div>

            <p className="forgot-password">
              <a href="/forgot-password" className="link">
                Forgot Password?
              </a>
            </p>

            <button
              type="submit"
              disabled={isSigningIn}
              className={`button ${isSigningIn ? "disabled" : ""}`}
            >
              {isSigningIn ? "Logging In..." : "Login"}
            </button>
          </form>

          <p className="form-footer">
            Don't have an account?{" "}
            <a href="/register" className="link">
              Sign up
            </a>
          </p>
        </div>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default Login;
